// frontend/src/services/deliveryService.js

import api from './api';

const deliveryService = {
  // ============================================
  // ХҮРГЭЛТ ШИВЭХ
  // ============================================
  createDelivery: async (data) => {
    try {
      const response = await api.post('/deliveries/create', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Хүргэлт үүсгэхэд алдаа гарлаа' };
    }
  },

  // ============================================
  // ХҮРГЭЛТҮҮД ХАРАХ (Filter + Pagination)
  // ============================================
  getDeliveries: async (params = {}) => {
    try {
      const response = await api.get('/deliveries', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Хүргэлтүүд татахад алдаа гарлаа' };
    }
  },

  // ============================================
  // СТАТИСТИК
  // ============================================
  getDeliveryStats: async (params = {}) => {
    try {
      const response = await api.get('/deliveries/stats', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Статистик татахад алдаа гарлаа' };
    }
  },

  // ============================================
  // ДЭЛГЭРЭНГҮЙ
  // ============================================
  getDeliveryById: async (id) => {
    try {
      const response = await api.get(`/deliveries/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Хүргэлтийн мэдээлэл татахад алдаа гарлаа' };
    }
  },

  // ============================================
  // ТӨЛӨВ ӨӨРЧЛӨХ
  // ============================================
  updateDeliveryStatus: async (id, data) => {
    try {
      const response = await api.patch(`/deliveries/${id}/status`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Төлөв өөрчлөхөд алдаа гарлаа' };
    }
  },

  // ============================================
  // ЖОЛООЧИД ТАТАХ
  // ============================================
  getDrivers: async () => {
    try {
      const response = await api.get('/deliveries/drivers-list');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Жолоочид татахад алдаа гарлаа' };
    }
  },

  // ============================================
  // ЖОЛООЧ ХУВИАРЛАХ (Single)
  // ============================================
  assignDriver: async (deliveryId, driverId) => {
    try {
      const response = await api.patch(`/deliveries/${deliveryId}/assign-driver`, { 
        driver_id: driverId 
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Жолооч хувиарлахад алдаа гарлаа' };
    }
  },

  // Жолоочийн хувиарлалт цуцлах
  unassignDriver: async (deliveryId) => {
    try {
      const response = await api.patch(`/deliveries/${deliveryId}/unassign`);
      return response.data;
    } catch (error) {
      console.error('❌ Unassign error:', error.response?.data);
      throw error.response?.data || { message: 'Хувиарлалт цуцлахад алдаа гарлаа' };
    }
  },

  // ============================================
  // BULK ХУВИАРЛАХ (Multiple) - ШИНЭЧЛЭГДСЭН
  // ============================================
  bulkAssignDriver: async (deliveryIds, driverId, zoneId = null, deliveryFee = null, useDefaultFee = false, deliveryFeeFromCustomer = false) => {
    try {
      const payload = {
        delivery_ids: deliveryIds,
        driver_id: driverId
      };

      // Zone-based assignment
      if (zoneId) {
        payload.zone_id = zoneId;
      }
      // Manual fee assignment
      else if (deliveryFee !== null && deliveryFee !== undefined) {
        payload.delivery_fee = deliveryFee;
      }
      // Use shop's default fee
      else if (useDefaultFee) {
        payload.use_default_fee = true;
      }

      // Хүргэлтийн төлбөрийг захиалагчаас авах эсэх
      payload.delivery_fee_from_customer = deliveryFeeFromCustomer;

      console.log('📦 Bulk assign payload:', payload);

      const response = await api.post('/deliveries/bulk-assign', payload);
      return response.data;
    } catch (error) {
      console.error('❌ Bulk assign error:', error.response?.data);
      throw error.response?.data || { message: 'Bulk хувиарлахад алдаа гарлаа' };
    }
  }
};

export default deliveryService;